import '../../styles/style.css'
function TodoDate () {
    return (
        <p className='todo-date'>July 17, 2024</p>
    )
}
export {TodoDate}